import React, { useMemo, useId } from "react";

const CurvedTextWithBackground = ({
  text = "Curved Text",
  textColor = "white",
  backgroundColor = "red",
  radius = 100,
  textSize = 20,
  strokeWidth = 70,
  startAngle = 180,
  arcDirection = "outside",
  lengthAdjustment = 0.95,
  fontFamily = "CiscoSans",
  fontWeight = "200"
}) => {
  const uniqueId = useId(); // Genera un ID único para cada instancia
  const textPathId = `textPath-${uniqueId}`; // ID único para el path del texto
  
  const center = radius;
  const toRad = (deg) => (deg - 90) * (Math.PI / 180);
  const directionFactor = arcDirection === "inside" ? -1 : 1;

  const [path, textPath, dyAdjustment] = useMemo(() => {
    // Calcular longitud del texto
    const textLength = text.length * textSize * 0.6 * lengthAdjustment;
    const arcRadians = (textLength / radius) * directionFactor;
    
    const start = toRad(startAngle);
    const end = start + arcRadians;
    
    // Configurar flags para el path
    const largeArcFlag = Math.abs(arcRadians) > Math.PI ? 1 : 0;
    const sweepFlag = arcDirection === "outside" ? 1 : 0;

    // Crear paths
    const mainPath = `M ${center + center * Math.cos(start)} ${center + center * Math.sin(start)}
                     A ${center} ${center} 0 ${largeArcFlag} ${sweepFlag} 
                     ${center + center * Math.cos(end)} ${center + center * Math.sin(end)}`;

    // Path para fondo (ligeramente más corto)
    const bgStart = start + (0.005 * directionFactor);
    const bgEnd = end - (0.005 * directionFactor);
    const bgPath = `M ${center + center * Math.cos(bgStart)} ${center + center * Math.sin(bgStart)}
                   A ${center} ${center} 0 ${largeArcFlag} ${sweepFlag} 
                   ${center + center * Math.cos(bgEnd)} ${center + center * Math.sin(bgEnd)}`;

    // Ajuste vertical invertido para dirección interna
    const dy = (-strokeWidth * 0.15 + textSize * 0.28) * directionFactor;

    return [bgPath, mainPath, dy];
  }, [text, radius, textSize, startAngle, arcDirection, lengthAdjustment]);

  return (
    <div style={{ 
      position: "relative", 
      width: radius * 2, 
      height: radius * 2
    }}>
      <svg
        viewBox={`0 0 ${radius * 2} ${radius * 2}`}
        style={{ overflow: "visible" }}
      >
        {/* Fondo */}
        <path
          d={path}
          fill="none"
          stroke={backgroundColor}
          strokeWidth={strokeWidth}
          strokeLinecap="butt"
        />
        
        {/* Texto con ID único */}
        <path
          id={textPathId}
          d={textPath}
          fill="none"
          stroke="none"
        />
        <text
          fontSize={textSize}
          fill={textColor}
          textAnchor="middle"
          dominantBaseline="central"
          fontFamily={fontFamily}
          fontWeight={fontWeight}
        >
          <textPath
            href={`#${textPathId}`} // Referencia al ID único
            startOffset="50%"
            dy={dyAdjustment}
            letterSpacing="0.5"
          >
            {text}
          </textPath>
        </text>
      </svg>
    </div>
  );
};

export default CurvedTextWithBackground;